import { TeamOutlined } from '@ant-design/icons';
import { ComingSoonPage } from '@/components/ComingSoonPage';

export function ReviewersPage() {
  return (
    <ComingSoonPage
      accent="ink"
      icon={<TeamOutlined />}
      title="Reviewers"
      subtitle="Clinical reviewer roster and category assignments"
      description="The clinicians (oncologists, pharmacists, RNs) authorized to sign off on agents in this merchant. Each reviewer is mapped to scenario categories matching their expertise — only their assigned categories block their stage gates."
      eta="H2"
      features={[
        { label: 'Reviewer roster', description: 'Name, role, specialty, assigned categories (A–L), sign-off history' },
        { label: 'Category mapping', description: 'Pharmacist → categories B + I; Oncology MD → A + B; etc.' },
        { label: 'Reviewer dashboard', description: 'Per reviewer: pending assignments, recent sign-offs, average turnaround' },
        { label: 'Invitation flow', description: 'Invite a clinician via email; auto-provisions role-scoped access' },
        { label: 'Review SLA tracking', description: 'Surface assignments overdue against the team\'s agreed turnaround' },
      ]}
    />
  );
}
